module.exports = __webpack_public_path__ + "img/1.07.6b2f4178.jpg";